import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Plus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 6 7"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <mask maskUnits="userSpaceOnUse" x="0" y="0" width="6" height="7">
          <rect y="0.769531" width="6" height="6" />
        </mask>
        <g mask="url(#mask0_1778_895)">
          <path d="M3.75 0.769531H2.25V3.01953H0V4.51953H2.25V6.76953H3.75V4.51953H6V3.01953H3.75V0.769531Z" />
        </g>
      </g>
    </svg>
  );
};

Plus.displayName = 'Plus';
